import { createModel } from "hox";
import React, { useState } from "react";
import { dictService } from "./dictService"
import { filterArrId, Optios, transPgToPagination } from "../../../utils/utils"
import { TablePaginationConfig } from "antd/es/table/interface";
import { IDictDetail, IDictInsert, IDictUpdata, IDictRemove, IDictDisable } from "./dictTypes"
import { globalPrompt } from "../../../components2/YhMessage"
import { useMdmModel } from "../../../model/mdmModel"
function listChangeTree(list: IDictDetail[]) {
    let menuObj: any = {}
    list.forEach(item => {
        item.children = []
        item.title = item.name
        menuObj[item.code as string] = item
    })
    return list.filter(item => {
        if (item.pcode !== null && item.pcode !== "") {
            menuObj[item.pcode as string]?.children.push(item)
            return false
        }
        return true
    })
}
export const useDictModel = createModel(function () {
    const { initDictDatas } = useMdmModel()
    const initDictData: IDictDetail[] = []
    // const initDictTreeRow:IDictDetail = {}
    const [dictData, setDictData] = useState([]);
    const [selectDictRowKey, setSelectDictRowKey] = useState<React.Key[]>([])
    const [selectDictRow, setSelectDictRow] = useState<IDictDetail>({});
    const [selectDictPRow, setSelectDictPRow] = useState<IDictDetail | undefined>();
    const [addTreeFrom, setAddTreeFrom] = useState<IDictInsert>({})
    const [page, setPage] = useState<TablePaginationConfig>({});
    const [optType, setOptType] = useState<number>(1)
    const [root, setRoot] = useState<boolean>(false)
    const loadDictData = async () => {
        const params = {
            page: {
                pageSize: 10000,
                pageNum: 1
            }
        }
        const { retData } = await dictService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        // const arrSort = records.sort((a: any, b: any) => a.code.length - b.code.length)
        setDictData(listChangeTree(records) as never[])
        initDictDatas()
    }
    const changeTreeForm = (value: any) => {
        setSelectDictRow({ ...selectDictRow, ...value })
    }
    const insertTreeForm = (value: any) => {
        setAddTreeFrom({ ...addTreeFrom, ...value })
    }
    const updataTreeForm = async () => {
        const params = {
            ...selectDictRow,
            enable: selectDictRow.enable ? 1 : 0,
            sourceApp: "mdm",
        }

        const { retData, retMsg } = await dictService.update(params)
        await globalPrompt("message", { type: "success", text: retMsg });
        await loadDictData()
    }
    const addPeerTreeForm = async () => {
        const params = {
            ...addTreeFrom,
            enable: addTreeFrom.enable ? 1 : 0,
            sourceApp: "mdm",
        }
        const { retData, retMsg } = await dictService.insert(params)
        await globalPrompt("message", { type: "success", text: retMsg });
        await loadDictData()
    }
    const removeTreeForm = async () => {
        const params = {
            ...selectDictRow,
            enable: selectDictRow.enable ? 1 : 0,
            sourceApp: "mdm",
        }
        const { retData, retMsg } = await dictService.remove(params)
        await globalPrompt("message", { type: "success", text: "删除成功" });
        await loadDictData()
    }
    return {
        dictData,
        selectDictRow,
        selectDictRowKey,
        selectDictPRow,
        page,
        optType,
        addTreeFrom,
        root,
        setDictData,
        loadDictData,
        setSelectDictRow,
        setSelectDictPRow,
        setPage,
        setSelectDictRowKey,
        changeTreeForm,
        insertTreeForm,
        updataTreeForm,
        setOptType,
        setAddTreeFrom,
        setRoot,
        addPeerTreeForm,
        removeTreeForm
    }
});